export default "__VITE_ASSET__BmHU4mCH__"